import React from 'react';
import { substractArrays } from 'buzz_lib_shared';
import { TagPicker } from '../TagPicker';
import { jsx as _jsx } from "react/jsx-runtime";
export const AsyncTagPicker = _ref => {
  let {
    searchMethod,
    isDisabled,
    inputProps = {
      placeholder: 'Type to start search...'
    },
    pickerCalloutProps,
    pickerSuggestionsProps,
    itemLimit,
    onChange,
    dataId,
    value
  } = _ref;
  const getSearchResults = filter => searchMethod(filter);
  const onResolveSuggestions = async (filter, selectedItems) => {
    if (!filter || !selectedItems) return [];
    const searchResults = await getSearchResults(filter);
    const selectedItemKeys = selectedItems.map(item => item.key);
    const filteredSearchResults = substractArrays(searchResults, selectedItemKeys, (searchResult, selectedKey) => selectedKey === searchResult.key);
    return filteredSearchResults;
  };
  return /*#__PURE__*/_jsx(TagPicker, {
    onResolveSuggestions: onResolveSuggestions,
    onChange: onChange,
    selectedItems: value,
    disabled: isDisabled,
    dataId: dataId,
    itemLimit: itemLimit,
    inputProps: inputProps,
    styles: {
      input: {
        backgroundColor: "rgb(255, 255, 255)"
      }
    },
    pickerSuggestionsProps: pickerSuggestionsProps,
    pickerCalloutProps: pickerCalloutProps
  });
};